export default __webpack_public_path__ + "static/media/fastlane_perspective.cec6b529.jpg";